import { useState } from "react";
import { useLenis } from "../../hooks/useLenis";
import Nav from "../site/Nav";
import CTABand from "../site/CTABand";
import Footer from "../site/Footer";
import ContactDialog from "../site/ContactDialog";

export default function PageLayout({ testId, children, showCta = true }) {
  const [contactOpen, setContactOpen] = useState(false);
  useLenis();
  const openContact = () => setContactOpen(true);

  return (
    <main data-testid={testId} className="bg-ivory text-charcoal font-body overflow-x-clip">
      <Nav onContact={openContact} />
      {typeof children === "function" ? children(openContact) : children}
      {showCta && <CTABand onContact={openContact} />}
      <Footer />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </main>
  );
}
